var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10.3746L12.425 9.29961L17 3.49961H6.62502L5.12502 1.99961H18.3C18.65 1.99961 18.9084 2.15794 19.075 2.47461C19.2417 2.79128 19.2084 3.09128 18.975 3.37461L13.5 10.3746ZM19.325 20.4746L13 14.1496V16.9996C13 17.2829 12.9042 17.5204 12.7125 17.7121C12.5209 17.9038 12.2834 17.9996 12 17.9996H10C9.71669 17.9996 9.47919 17.9038 9.28752 17.7121C9.09586 17.5204 9.00002 17.2829 9.00002 16.9996V10.1496L0.525024 1.67461L1.60002 0.599609L20.4 19.3996L19.325 20.4746Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterClose);
export default __webpack_public_path__ + "static/media/filter-close.757ce25b745b22ea2515c684142013d5.svg";
export { ForwardRef as ReactComponent };